import { render } from "./h5Manage.vue?vue&type=template&id=0162d7c4&scoped=true"
import script from "./h5Manage.vue?vue&type=script&lang=js"
export * from "./h5Manage.vue?vue&type=script&lang=js"

import "./h5Manage.vue?vue&type=style&index=0&id=0162d7c4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0162d7c4"]])

export default __exports__